export default "__VITE_ASSET__DlyZ9kLo__"